module.exports = __webpack_public_path__ + "static/img/xf2.ddb4e26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/xf2.png
// module id = /9Fc
// module chunks = 0